import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import dt from '../../../shared/theme';
import plural from '../../shared/format';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 48px;

  ${props => dt(props).theme.isLarge && `
    margin-top: 64px;
  `};
`;

const Number = styled.div`
  font: ${props => dt(props).theme.fontWeightBold} 14px/17px ${props => dt(props).theme.fontFamilyBody};
  text-transform: uppercase;
`;

const Title = styled.div`
  font: ${props => dt(props).theme.fontWeightMedium} 40px/48px ${props => dt(props).theme.fontFamilyBody};
  letter-spacing: -0.02em;
  text-transform: capitalize;
`;

const Separator = styled.div`
  width: 100%;
  height: 0px;
  border: none;
  border-bottom: 1px solid #D7DFE7;
  margin-top: 24px;
`;

export default function Headline({ total }) {
  return (
    <Container>
      <Number>
        {total}
        &nbsp;
        {`wire${plural(total)}`}
      </Number>
      <Title>All Wires</Title>
      <Separator />
    </Container>
  );
}

Headline.propTypes = {
  total: PropTypes.number.isRequired,
};
